import { render, staticRenderFns } from "./accountsReceiveDeptDataSingle.vue?vue&type=template&id=56ac276a&scoped=true&"
import script from "./accountsReceiveDeptDataSingle.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveDeptDataSingle.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveDeptDataSingle.vue?vue&type=style&index=0&id=56ac276a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac276a",
  null
  
)

export default component.exports